import React, { useState } from "react";

function MilpitasFAQs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const isActive = (index) => activeIndex === index;

  const faqs = [
    {
      question: "What types of items do you remove?",
      answer:
        "We remove everything from unwanted items, old furniture, and old appliances to construction debris, scrap metal, yard waste, and hazardous materials. Whether it’s a single item or a large estate cleanout, we’ve got you covered.",
    },
    {
      question: "How do I get a free estimate?",
      answer:
        "Simply enter your Zip Code or call our Phone Number to request a free estimate or Free Quote. Our transparent pricing model ensures you know the cost upfront, with no hidden fees.",
    },
    {
      question: "Do you offer same-day service?",
      answer:
        "Yes! We provide both same-day and next-day service to meet your junk removal needs quickly and efficiently.",
    },
    {
      question: "Is your disposal eco-friendly?",
      answer:
        "Absolutely. We follow responsible disposal practices to minimize environmental impact through eco-friendly disposal and recycling programs.",
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion junk-faq-sec">
          {faqs.map((faq, index) => (
            <div
              className={`accordion-item ${isActive(index) ? "active" : ""}`}
              key={index}
            >
              <div
                className="accordion-item-header"
                onClick={() => handleAccordionClick(index)}
                style={{ color: isActive(index) ? "blue" : "#000" }}
              >
                <span className="accordion-item-header-title">
                  <img
                    src={
                      isActive(index)
                        ? "/assets/img/question-mark-yellow.svg"
                        : "/assets/img/_Compound Path_.png"
                    }
                    alt="default"
                    loading="lazy"
                    className="accordion-image"
                  />
                  <p>{faq.question}</p>
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                    style={{ color: isActive(index) ? "#2d6bd6" : "#000" }}
                  />
                </svg>
              </div>
              <div
                className={`accordion-item-description-wrapper ${
                  isActive(index) ? "open" : ""
                }`}
                style={{ display: isActive(index) ? "block" : "none" }}
              >
                <div className="accordion-item-description">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default MilpitasFAQs;
